module.exports = __webpack_public_path__ + "assets/img/5fb954965561045bfeebbc6a6cc86ad1.png";